var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBestScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5476 28.7997H24.4373C25.3369 28.7997 26.0662 29.5159 26.0662 30.3995C26.0662 31.283 25.3369 31.9993 24.4373 31.9993H11.4062C10.5066 31.9993 9.77734 31.283 9.77734 30.3995C9.77734 29.5159 10.5066 28.7997 11.4062 28.7997H16.2898V20.8008H19.5476V28.7997Z",
    fill: "#0C3450",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51552 6.3949H3.25776V9.59449C3.25776 11.3616 4.71631 12.7941 6.51552 12.7941V6.3949ZM3.25776 3.19531C1.45855 3.19531 0 4.62782 0 6.3949V9.59449C0 13.1287 2.9171 15.9937 6.51552 15.9937H9.77329V3.19531H3.25776Z",
    fill: "#0C3450",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3204 6.3949H32.5782V9.59449C32.5782 11.3616 31.1196 12.7941 29.3204 12.7941V6.3949ZM32.5782 3.19531C34.3774 3.19531 35.8359 4.62782 35.8359 6.3949V9.59449C35.8359 13.1287 32.9188 15.9937 29.3204 15.9937H26.0627V3.19531H32.5782Z",
    fill: "#0C3450",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51172 2C6.51172 0.895433 7.40715 0 8.51172 0H27.3161C28.4206 0 29.3161 0.895431 29.3161 2V15.9969C29.3161 20.4152 25.7343 23.9969 21.3161 23.9969H14.5117C10.0934 23.9969 6.51172 20.4152 6.51172 15.9969V2Z",
    fill: "#0C3450"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestScore);
export default __webpack_public_path__ + "static/media/BestScore.53cc26cdc5caf48c33b235422b4ca004.svg";
export { ForwardRef as ReactComponent };